// Shared menu item types
export type SpiceLevel = 'NONE' | 'MILD' | 'MEDIUM' | 'HOT' | 'EXTRA_HOT'

export interface SpiceLevelInfo {
  level: number
  displayName: string
  icon: string
  color: string
}

export const SPICE_LEVELS: Record<SpiceLevel, SpiceLevelInfo> = {
  NONE: { level: 0, displayName: 'No Spice', icon: '', color: 'var(--text-tertiary)' },
  MILD: { level: 1, displayName: 'Mild', icon: '🌶️', color: 'var(--status-ok)' },
  MEDIUM: { level: 2, displayName: 'Medium', icon: '🌶️🌶️', color: 'var(--status-warn)' },
  HOT: { level: 3, displayName: 'Hot', icon: '🌶️🌶️🌶️', color: 'var(--status-bad)' },
  EXTRA_HOT: { level: 4, displayName: 'Extra Hot', icon: '🌶️🌶️🌶️🌶️', color: 'var(--status-bad-text)' }
}

export interface Topping {
  id: number
  name: string
  price: number
  description?: string
  isAvailable: boolean
  displayOrder: number
}

export type Kitchen = {
  id: number
  name: string
  kitchenType: string
  isActive: boolean
  isDefault: boolean
  displayName?: string
}

export interface MenuItemPortion {
  id: number
  portionName: string
  priceModifier: number
  isDefault: boolean
  displayOrder: number
  effectivePrice?: number
  displayPrice?: string
}

export interface MenuItem {
  id: number
  name: string
  description?: string
  price: number
  isAvailable: boolean
  quantity?: number
  toppings?: Topping[]
  imageUrl?: string
  imageKey?: string
  freeToppingsCount?: number
  extraToppingPrice?: number
  menu?: { id: number; name?: string }
  kitchen?: Kitchen
  kitchenId?: number
  portions?: MenuItemPortion[]
  spiceLevel?: SpiceLevel
  allowsSpiceCustomization?: boolean
  /** UK 14-allergen declaration (backend enum names, e.g. "PEANUTS") */
  allergens?: string[]
  allergenNote?: string
  /** Positive "no known allergens" declaration; mutually exclusive with allergens */
  allergenFree?: boolean
  /** Dietary marker (VEG/NON_VEG/VEGAN); absent/null = undeclared */
  dietaryType?: 'VEG' | 'NON_VEG' | 'VEGAN' | null
}
export interface MenuCategory {
  id: number
  name: string
  description: string
  imageKey?: string
  imageUrl?: string
  items: MenuItem[]
}